class LivelabelManagerWrapper {
    constructor(livelabelManager, modifyCallback) {
        this._livelabelManager = livelabelManager;

        this._modifyDepth = 0;
        this._modifyCallback = modifyCallback;
    }

    _incrementModifyDepth() {
        this._modifyDepth++;
    }

    _decrementModifyDepth() {
        if (this._modifyDepth === 0) {
            throw Error("modifyDepth already at 0");
        }

        this._modifyDepth--;

        if (this._modifyDepth === 0) {
            try {
                this._modifyCallback();
            } catch (error) {
                console.error(error);
            }
        }
    }

    _modifyingCall(callback) {
        this._incrementModifyDepth();

        try {
            return callback();
        } finally {
            this._decrementModifyDepth();
        }
    }

    get language() { return this._livelabelManager.language; }
    set language(val) { this._livelabelManager.language = val; }
    get isHovering() { return this._livelabelManager.isHovering; }
    set isHovering(val) { this._livelabelManager.isHovering = val; }
    get lastHighligthedLabel() { return this._livelabelManager.lastHighligthedLabel; }
    set lastHighligthedLabel(val) { this._livelabelManager.lastHighligthedLabel = val; }
    get lastHighligthedLabelObject() { return this._livelabelManager.lastHighligthedLabelObject; }

    getTextLiveLabels() {
        return this._livelabelManager.getTextLiveLabels();
    }

    clear() {
        return this._modifyingCall(() => this._livelabelManager.clear());
    }

    clearLast() {
        return this._livelabelManager.clearLast();
    }

    createMissingLabels() {
        return this._modifyingCall(() => this._livelabelManager.createMissingLabels());
    }

    get labelsLerping() {
        return this._livelabelManager.labelsLerping;
    }

    get labelsTransitioning() {
        return this._livelabelManager.labelsTransitioning;
    }

    updateTransition() {
        return this._livelabelManager.updateTransition();
    }

    update(force = false, teacherData = null) {
        return this._livelabelManager.update(force, teacherData);
    }

    getTeacherLabelsPosition() {
        return this._livelabelManager.getTeacherLabelsPosition();
    }

    getTeacherLabelsVisibility() {
        return this._livelabelManager.getTeacherLabelsVisibility();
    }

    computeLabelValidty() {
        return this._livelabelManager.computeLabelValidty();
    }

    setGlobalVisibility(type) {
        return this._livelabelManager.setGlobalVisibility(type);
    }

    applyTeacherLabelsPosition(isCallouts) {
        return this._livelabelManager.applyTeacherLabelsPosition(isCallouts);
    }

    createTeacherData(potentialLabels, invisibleLabels) {
        return this._livelabelManager.createTeacherData(potentialLabels, invisibleLabels);
    }

    updatePotential(potentialLabels, invisibleLabels) {
        return this._livelabelManager.updatePotential(potentialLabels, invisibleLabels);
    }

    computeCallouts() {
        return this._livelabelManager.computeCallouts();
    }

    get isLocked() { return this._livelabelManager.isLocked; }

    get regionOverlay() { return this._livelabelManager.regionOverlay; }
    get selectedRegion() { return this._livelabelManager.selectedRegion; }
    get isDisplayingRegions() { return this._livelabelManager.isDisplayingRegions; }
    get isDrawingRegion() { return this._livelabelManager.isDrawingRegion; }

    get highlighted() { return this._livelabelManager.highlighted; }

    setLocked(isLocked) {
        return this._livelabelManager.setLocked(isLocked);
    }

    setSelectedRegion(object, idxRegion) {
        return this._livelabelManager.setSelectedRegion(object, idxRegion);
    }

    clearSelectedRegion() {
        return this._livelabelManager.clearSelectedRegion();
    }

    getMeshLabel(object) {
        return this._modifyingCall(() => this._livelabelManager.getMeshLabel(object));
    }

    selectRegion(object, index) {
        return this._livelabelManager.selectRegion(object, index);
    }

    getLabelByUuid(object, uuid) {
        return this._livelabelManager.getLabelByUuid(object, uuid);
    }

    getAllLabelTexts() {
        return this._livelabelManager.getAllLabelTexts();
    }

    getLabelData(object) {
        return this._livelabelManager.getLabelData(object);
    };

    getAllLabels(object) {
        return this._livelabelManager.getAllLabels(object);
    }

    getAllVisibleLabels() {
        return this._livelabelManager.getAllVisibleLabels();
    }

    intersectRegion(mesh, raycaster, camera, position) {
        return this._livelabelManager.intersectRegion(mesh, raycaster, camera, position);
    }

    addRegion(object) {
        return this._modifyingCall(() => this._livelabelManager.addRegion(object));
    }

    hasMeshLabel(object) { return this._livelabelManager.hasMeshLabel(object); }

    alert() {
        return this._livelabelManager.alert();
    }

    initMeshLabel(object, intersection) {
        return this._modifyingCall(() => this._livelabelManager.initMeshLabel(object, intersection));
    }

    deleteMeshLabel(label) {
        return this._modifyingCall(() => this._livelabelManager.deleteMeshLabel(label));
    }

    toggleRegionCreation(object, intersection) {
        return this._modifyingCall(() => this._livelabelManager.toggleRegionCreation(object, intersection));
    }

    createLabelForRegion(object, intersection) {
        return this._modifyingCall(() => this._livelabelManager.createLabelForRegion(object, intersection));
    }

    toggleDisplayRegions() {
        return this._livelabelManager.toggleDisplayRegions();
    }

    resetClippingDistance(object, label, data) {
        return this._modifyingCall(() => this._livelabelManager.resetClippingDistance(object, label, data));
    }

    resetGlobalRange() {
        return this._modifyingCall(() => this._livelabelManager.resetGlobalRange());
    }

    setLabelData(object, label, data) {
        return this._modifyingCall(() => this._livelabelManager.setLabelData(object, label, data));
    }

    setMeshLabel(object, data) {
        return this._modifyingCall(() => this._livelabelManager.setMeshLabel(object, data));
    }

    setActiveRegion(object, region) {
        return this._modifyingCall(() => this._livelabelManager.setActiveRegion(object, region));
    }

    getActiveRegion(object) {
        return this._livelabelManager.getActiveRegion(object);
    }

    getActiveLabel(object) {
        return this._livelabelManager.getActiveLabel(object);
    }

    get blobCreationEnabled() { return this._livelabelManager.blobCreationEnabled; }

    stopBlobing() {
        return this._livelabelManager.stopBlobing();
    }

    stopBlob() {
        return this._modifyingCall(() => this._livelabelManager.stopBlob());
    }

    removeBlob(blob) {
        return this._modifyingCall(() => this._livelabelManager.removeBlob(blob));
    }

    cancelBlob() {
        return this._modifyingCall(() => this._livelabelManager.cancelBlob());
    }

    moveBlob(intersection) {
        return this._livelabelManager.moveBlob(intersection);
    }

    modifyBlob(intersection) {
        return this._livelabelManager.modifyBlob(intersection);
    }

    addBlobAndForget(object, intersection) {
        return this._modifyingCall(() => this._livelabelManager.addBlobAndForget(object, intersection));
    }

    hideCallouts() {
        return this._livelabelManager.hideCallouts();
    }

    addBlob(object, intersection) {
        return this._modifyingCall(() => this._livelabelManager.addBlob(object, intersection));
    }

    updateBlob(object, raycaster) {
        return this._modifyingCall(() => this._livelabelManager.updateBlob(object, raycaster));
    }

    renderRegions(camera, object, noHighlight = false) {
        return this._livelabelManager.renderRegions(camera, object, noHighlight);
    }

    getLabelForRegion(regionId) {
        return this._livelabelManager.getLabelForRegion(regionId);
    }

    setHighlightLabel(label, isHighlighted, is2D) {
        return this._livelabelManager.setHighlightLabel(label, isHighlighted, is2D);
    }

    serialize() {
        return this._livelabelManager.serialize();
    }

    deserialize(version, object, data) {
        return this._modifyingCall(() => this._livelabelManager.deserialize(version, object, data));
    }

    addLabel(object, meshLabel, label, index) {
        return this._modifyingCall(() => this._livelabelManager.addLabel(object, meshLabel, label, index));
    }

    undeleteLabel(object, labelData) {
        return this._modifyingCall(() => this._livelabelManager.undeleteLabel(object, labelData));
    }



    /*
     * The following members aren't supposed to be here because
     * they're private but they're used directly in multiple places
     * in the code so we have to expose them as public members
     */

    get _meshLabels() { return this._livelabelManager._meshLabels; };
    get _teacherData() { return this._livelabelManager._teacherData; };

    _renderLabels(teacherData = null) {
        return this._livelabelManager._renderLabels(teacherData);
    }
}

export default LivelabelManagerWrapper;
